jQuery(function($){
  jQuery(document).ready(function(){

    // reviews slider
    if ($('.reviews .reviews-wrapper').length > 0) {
      var handleReviewsSlides = function() {
        
        var $grid = $(".reviews .reviews-wrapper").masonry({
          itemSelector: ".reviews .reviews-wrapper .single",
          columnWidth: ".reviews .reviews-wrapper .single",
          percentPosition: true,
          gutter: 20,
          fitWidth: true
        });
        
      };

      handleReviewsSlides();
      $(window).on('resize', function(){
        setTimeout(function(){
          handleReviewsSlides();
        }, 100);
      });
    }
  });
});